"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKpoPrintData = getKpoPrintData;
exports.kpoCardPrintSheet = kpoCardPrintSheet;
exports.insertKpoPrintData = insertKpoPrintData;
var headers_1 = require("../headers");
var kpo_card_1 = require("./kpo_card");
var common_1 = require("../common");
var line = headers_1.KPO_PRINT_LINE;
var headers = headers_1.KPO_PRINT_HEADERS;
/**
 * Metoda getKpoPrintData pobiera dane i zwraca pojedyńczy obiekt KpoCardPrint wywołując metodę getKpoPrintDataAndMaping która zwraca dokładnie te same pola w wyniku zapytania co w KpoCardPrint.
 * Nie wymaga uzupełniania ani dodawania danych, ani automatycznie, ani ręcznie
 * @param eupType Typ EUP
 * @param cardNumber Numer karty KPO
 * @returns Obiekt KpoCardPrint zawierający dane do wydruku karty KPO
 */
function getKpoPrintData(eupType, cardNumber) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, kpo_card_1.getKpoPrintDataAndMaping)(eupType, cardNumber)];
                case 1:
                    result = _a.sent();
                    // Sprawdzenie czy dane zostały poprawnie pobrane
                    if (!result || !result.printData) {
                        throw new Error("Nie udało się pobrać danych do wydruku karty KPO");
                    }
                    return [2 /*return*/, result];
            }
        });
    });
}
/**
 * Metoda printLayer tworzy strukturę arkusza do wydruku karty KPO do uzupełnienia pobranymi danymi obiektu KpoCardPrint w odrębnej metodzie
 * @param sheetName Nazwa arkusza
 * @param eupType: EupType Typ EUP
 */
function kpoCardPrintSheet(sheetName, eupType) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, lineHeader, lineData, lineSeparator, page, HEADER_0, LINE_0_1, LINE_0_1_d, LINE_0_2, LINE_0_2_d, LINE_0_3, LINE_0_3_d, HEADER_1, LINE_1_1, LINE_1_1_d, LINE_1_2, LINE_1_2_d, LINE_1_3, LINE_1_3_d, LINE_1_4, LINE_1_4_d, LINE_1_5, LINE_1_5_d, LINE_1_6, LINE_1_6_d, LINE_1_7, LINE_1_7_d, LINE_1_8, LINE_1_8_d, LINE_1_9, LINE_1_9_d, LINE_1_10, LINE_1_10_d, LINE_1_11, LINE_1_11_d, HEADER_2, LINE_2_1, LINE_2_1_d, LINE_2_2, LINE_2_2_d, LINE_2_3, LINE_2_3_d, LINE_2_4, LINE_2_4_d, LINE_2_5, LINE_2_5_d, HEADER_3, LINE_3_1, LINE_3_1_d, LINE_3_2, LINE_3_2_d, LINE_3_3, LINE_3_3_d, LINE_3_4, LINE_3_4_d, LINE_3_5, LINE_3_5_d, LINE_3_6, LINE_3_6_d, LINE_3_7, LINE_3_7_d, LINE_3_8, LINE_3_8_d, HEADER_4, LINE_4_1, LINE_4_1_d, LINE_4_8, LINE_4_8_d, LINE_4_2, LINE_4_2_d, LINE_4_3, LINE_4_3_d, LINE_4_4, LINE_4_4_d, LINE_4_5, LINE_4_5_d, LINE_4_6, LINE_4_6_d, LINE_4_7, LINE_4_7_d, HEADER_5, LINE_5_1, LINE_5_1_d, LINE_5_2, LINE_5_2_d, LINE_5_3, LINE_5_3_d, LINE_5_4, LINE_5_4_d, LINE_5_5, LINE_5_5_d, HEADER_6, LINE_6_1, LINE_6_1_d, LINE_6_2, LINE_6_2_d, LINE_6_3, LINE_6_3_d, LINE_6_4, LINE_6_4_d, HEADER_7, HEADER_7A, LINE_7A_1, LINE_7A_1_d, LINE_7A_2, LINE_7A_2_d, LINE_7A_3, LINE_7A_3_d, HEADER_7B, LINE_7B_1, LINE_7B_1_d, LINE_7B_2, LINE_7B_2_d, LINE_7B_3, LINE_7B_3_d, HEADER_7C, LINE_7C_1, LINE_7C_1_d, LINE_7C_2, LINE_7C_2_d, LINE_7C_3, LINE_7C_3_d, HEADER_8, LINE_8_1, LINE_8_1_d, trialRow, copyrightRow;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    lineHeader = 16;
                                    lineData = 16;
                                    lineSeparator = 6;
                                    // Formatowanie kolumn - szerokość kolumn A i B
                                    sheet.getRange("A:A").format.columnWidth = 315;
                                    sheet.getRange("B:B").format.columnWidth = 35;
                                    sheet.getRange("C:C").format.columnWidth = 315;
                                    sheet.getRange("D:D").format.columnWidth = 35;
                                    sheet.getRange("E:E").format.columnWidth = 315;
                                    // Formatowanie wierszy - wysokość wierszy od 2 do 4
                                    sheet.getRange("1:1").format.rowHeight = 30;
                                    sheet.getRange("2:2").format.rowHeight = 10;
                                    sheet.getRange("3:3").format.rowHeight = lineHeader;
                                    sheet.getRange("4:4").format.rowHeight = lineData;
                                    sheet.getRange("5:5").format.rowHeight = 30;
                                    sheet.getRange("6:6").format.rowHeight = lineHeader;
                                    sheet.getRange("7:7").format.rowHeight = lineData;
                                    sheet.getRange("8:8").format.rowHeight = lineSeparator;
                                    sheet.getRange("9:9").format.rowHeight = lineHeader;
                                    sheet.getRange("10:10").format.rowHeight = lineData;
                                    sheet.getRange("11:11").format.rowHeight = lineSeparator;
                                    sheet.getRange("12:12").format.rowHeight = lineHeader;
                                    sheet.getRange("13:13").format.rowHeight = lineData;
                                    sheet.getRange("14:14").format.rowHeight = lineSeparator;
                                    sheet.getRange("15:15").format.rowHeight = lineHeader;
                                    sheet.getRange("16:16").format.rowHeight = lineData;
                                    sheet.getRange("17:17").format.rowHeight = lineSeparator;
                                    sheet.getRange("18:18").format.rowHeight = lineHeader;
                                    sheet.getRange("19:19").format.rowHeight = lineData;
                                    sheet.getRange("20:20").format.rowHeight = lineSeparator;
                                    sheet.getRange("21:21").format.rowHeight = lineHeader;
                                    sheet.getRange("22:22").format.rowHeight = lineData;
                                    sheet.getRange("23:23").format.rowHeight = lineSeparator;
                                    sheet.getRange("24:24").format.rowHeight = lineHeader;
                                    sheet.getRange("25:25").format.rowHeight = lineData;
                                    sheet.getRange("26:26").format.rowHeight = lineSeparator;
                                    sheet.getRange("27:27").format.rowHeight = lineHeader;
                                    sheet.getRange("28:28").format.rowHeight = lineData;
                                    sheet.getRange("29:29").format.rowHeight = lineSeparator;
                                    sheet.getRange("30:30").format.rowHeight = 30;
                                    sheet.getRange("31:31").format.rowHeight = lineHeader;
                                    sheet.getRange("32:32").format.rowHeight = lineData;
                                    sheet.getRange("33:33").format.rowHeight = lineSeparator;
                                    sheet.getRange("34:34").format.rowHeight = lineHeader;
                                    sheet.getRange("35:35").format.rowHeight = lineData;
                                    sheet.getRange("36:36").format.rowHeight = lineSeparator;
                                    sheet.getRange("37:37").format.rowHeight = lineHeader;
                                    sheet.getRange("38:38").format.rowHeight = lineData;
                                    sheet.getRange("39:39").format.rowHeight = lineSeparator;
                                    sheet.getRange("40:40").format.rowHeight = 30;
                                    sheet.getRange("41:41").format.rowHeight = lineHeader;
                                    sheet.getRange("42:42").format.rowHeight = lineData;
                                    sheet.getRange("43:43").format.rowHeight = lineSeparator;
                                    sheet.getRange("44:44").format.rowHeight = lineHeader;
                                    sheet.getRange("45:45").format.rowHeight = lineData;
                                    sheet.getRange("46:46").format.rowHeight = lineSeparator;
                                    sheet.getRange("47:47").format.rowHeight = lineHeader;
                                    sheet.getRange("48:48").format.rowHeight = lineData;
                                    sheet.getRange("49:49").format.rowHeight = lineSeparator;
                                    sheet.getRange("50:50").format.rowHeight = lineHeader;
                                    sheet.getRange("51:51").format.rowHeight = lineData;
                                    sheet.getRange("52:52").format.rowHeight = lineSeparator;
                                    sheet.getRange("53:53").format.rowHeight = lineHeader;
                                    sheet.getRange("54:54").format.rowHeight = lineData;
                                    sheet.getRange("55:55").format.rowHeight = lineSeparator;
                                    sheet.getRange("56:56").format.rowHeight = 30;
                                    sheet.getRange("57:57").format.rowHeight = lineHeader;
                                    sheet.getRange("58:58").format.rowHeight = lineData;
                                    sheet.getRange("59:59").format.rowHeight = lineSeparator;
                                    sheet.getRange("60:60").format.rowHeight = lineHeader;
                                    sheet.getRange("61:61").format.rowHeight = lineData;
                                    sheet.getRange("62:62").format.rowHeight = lineSeparator;
                                    sheet.getRange("63:63").format.rowHeight = lineHeader;
                                    sheet.getRange("64:64").format.rowHeight = lineData * 2;
                                    sheet.getRange("65:65").format.rowHeight = lineSeparator;
                                    sheet.getRange("66:66").format.rowHeight = lineHeader;
                                    sheet.getRange("67:67").format.rowHeight = lineData;
                                    sheet.getRange("68:68").format.rowHeight = lineSeparator;
                                    sheet.getRange("69:69").format.rowHeight = lineHeader;
                                    sheet.getRange("70:70").format.rowHeight = lineData;
                                    sheet.getRange("71:71").format.rowHeight = lineSeparator;
                                    sheet.getRange("72:72").format.rowHeight = lineHeader;
                                    sheet.getRange("73:73").format.rowHeight = lineData;
                                    sheet.getRange("74:74").format.rowHeight = lineSeparator;
                                    sheet.getRange("75:75").format.rowHeight = 30;
                                    sheet.getRange("76:76").format.rowHeight = lineHeader;
                                    sheet.getRange("77:77").format.rowHeight = lineData;
                                    sheet.getRange("78:78").format.rowHeight = lineSeparator;
                                    sheet.getRange("79:79").format.rowHeight = lineHeader;
                                    sheet.getRange("80:80").format.rowHeight = lineData;
                                    sheet.getRange("81:81").format.rowHeight = lineSeparator;
                                    sheet.getRange("82:82").format.rowHeight = lineHeader;
                                    sheet.getRange("83:83").format.rowHeight = lineData;
                                    sheet.getRange("84:84").format.rowHeight = lineSeparator;
                                    sheet.getRange("85:85").format.rowHeight = 30;
                                    sheet.getRange("86:86").format.rowHeight = lineHeader;
                                    sheet.getRange("87:87").format.rowHeight = lineData;
                                    sheet.getRange("88:88").format.rowHeight = lineSeparator;
                                    sheet.getRange("89:89").format.rowHeight = lineHeader;
                                    sheet.getRange("90:90").format.rowHeight = lineData * 2;
                                    sheet.getRange("91:91").format.rowHeight = lineSeparator;
                                    sheet.getRange("92:92").format.rowHeight = 30;
                                    sheet.getRange("93:93").format.rowHeight = 25;
                                    sheet.getRange("94:94").format.rowHeight = lineHeader;
                                    sheet.getRange("95:95").format.rowHeight = lineData;
                                    sheet.getRange("96:96").format.rowHeight = lineSeparator;
                                    sheet.getRange("97:97").format.rowHeight = 25;
                                    sheet.getRange("98:98").format.rowHeight = lineHeader;
                                    sheet.getRange("99:99").format.rowHeight = lineData;
                                    sheet.getRange("100:100").format.rowHeight = lineSeparator;
                                    sheet.getRange("101:101").format.rowHeight = 25;
                                    sheet.getRange("102:102").format.rowHeight = lineHeader;
                                    sheet.getRange("103:103").format.rowHeight = lineData;
                                    sheet.getRange("104:104").format.rowHeight = lineSeparator;
                                    sheet.getRange("105:105").format.rowHeight = 30;
                                    sheet.getRange("106:106").format.rowHeight = lineHeader;
                                    sheet.getRange("107:107").format.rowHeight = lineData * 4;
                                    sheet.getRange("108:108").format.rowHeight = lineSeparator;
                                    page = sheet.getRange("A1:E108");
                                    page.format.fill.color = "#FFFFFF";
                                    HEADER_0 = sheet.getRange("A1:E1");
                                    HEADER_0.merge();
                                    HEADER_0.format.fill.color = "#FFFFFF";
                                    HEADER_0.format.font.bold = false;
                                    HEADER_0.format.font.color = "#000000";
                                    HEADER_0.format.font.size = 22;
                                    HEADER_0.format.horizontalAlignment = "Left";
                                    HEADER_0.format.verticalAlignment = "Center";
                                    sheet.getRange("A1").values = [[headers.HEADER_0]];
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _a.sent();
                                    LINE_0_1 = sheet.getRange("A3");
                                    LINE_0_1.format.fill.color = "#688BBB";
                                    LINE_0_1.format.font.bold = true;
                                    LINE_0_1.format.font.color = "#FFFFFF";
                                    LINE_0_1.format.font.size = 10;
                                    LINE_0_1.format.horizontalAlignment = "Left";
                                    LINE_0_1.format.verticalAlignment = "Center";
                                    LINE_0_1.values = [[line.LINE_0_1]];
                                    LINE_0_1_d = sheet.getRange("A4");
                                    LINE_0_1_d.format.fill.color = "#D9D9D9";
                                    LINE_0_1_d.format.font.bold = false;
                                    LINE_0_1_d.format.font.color = "#000000";
                                    LINE_0_1_d.format.font.size = 11;
                                    LINE_0_1_d.format.horizontalAlignment = "Center";
                                    LINE_0_1_d.format.verticalAlignment = "Center";
                                    LINE_0_2 = sheet.getRange("C3");
                                    LINE_0_2.format.fill.color = "#688BBB";
                                    LINE_0_2.format.font.bold = true;
                                    LINE_0_2.format.font.color = "#FFFFFF";
                                    LINE_0_2.format.font.size = 10;
                                    LINE_0_2.format.horizontalAlignment = "Left";
                                    LINE_0_2.format.verticalAlignment = "Center";
                                    LINE_0_2.values = [[line.LINE_0_2]];
                                    LINE_0_2_d = sheet.getRange("C4");
                                    LINE_0_2_d.format.fill.color = "#D9D9D9";
                                    LINE_0_2_d.format.font.bold = false;
                                    LINE_0_2_d.format.font.color = "#000000";
                                    LINE_0_2_d.format.font.size = 11;
                                    LINE_0_2_d.format.horizontalAlignment = "Center";
                                    LINE_0_2_d.format.verticalAlignment = "Center";
                                    LINE_0_3 = sheet.getRange("E3");
                                    LINE_0_3.format.fill.color = "#688BBB";
                                    LINE_0_3.format.font.bold = true;
                                    LINE_0_3.format.font.color = "#FFFFFF";
                                    LINE_0_3.format.font.size = 10;
                                    LINE_0_3.format.horizontalAlignment = "Left";
                                    LINE_0_3.format.verticalAlignment = "Center";
                                    LINE_0_3.values = [[line.LINE_0_3]];
                                    LINE_0_3_d = sheet.getRange("E4");
                                    LINE_0_3_d.format.fill.color = "#D9D9D9";
                                    LINE_0_3_d.format.font.bold = false;
                                    LINE_0_3_d.format.font.color = "#000000";
                                    LINE_0_3_d.format.font.size = 11;
                                    LINE_0_3_d.format.horizontalAlignment = "Center";
                                    LINE_0_3_d.format.verticalAlignment = "Center";
                                    return [4 /*yield*/, context.sync()];
                                case 2:
                                    _a.sent();
                                    HEADER_1 = sheet.getRange("A5:E5");
                                    HEADER_1.merge();
                                    HEADER_1.format.fill.color = "#FFFFFF";
                                    HEADER_1.format.font.bold = false;
                                    HEADER_1.format.font.color = "#000000";
                                    HEADER_1.format.font.size = 16;
                                    HEADER_1.format.horizontalAlignment = "Left";
                                    HEADER_1.format.verticalAlignment = "Bottom";
                                    sheet.getRange("A5").values = [[headers.HEADER_1]];
                                    return [4 /*yield*/, context.sync()];
                                case 3:
                                    _a.sent();
                                    LINE_1_1 = sheet.getRange("A6");
                                    LINE_1_1.format.fill.color = "#688BBB";
                                    LINE_1_1.format.font.bold = true;
                                    LINE_1_1.format.font.color = "#FFFFFF";
                                    LINE_1_1.format.font.size = 10;
                                    LINE_1_1.format.horizontalAlignment = "Left";
                                    LINE_1_1.format.verticalAlignment = "Center";
                                    LINE_1_1.values = [[line.LINE_1_1]];
                                    LINE_1_1_d = sheet.getRange("A7");
                                    LINE_1_1_d.format.fill.color = "#D9D9D9";
                                    LINE_1_1_d.format.font.bold = false;
                                    LINE_1_1_d.format.font.color = "#000000";
                                    LINE_1_1_d.format.font.size = 11;
                                    LINE_1_1_d.format.horizontalAlignment = "Center";
                                    LINE_1_1_d.format.verticalAlignment = "Center";
                                    LINE_1_2 = sheet.getRange("C6");
                                    LINE_1_2.format.fill.color = "#688BBB";
                                    LINE_1_2.format.font.bold = true;
                                    LINE_1_2.format.font.color = "#FFFFFF";
                                    LINE_1_2.format.font.size = 10;
                                    LINE_1_2.format.horizontalAlignment = "Left";
                                    LINE_1_2.format.verticalAlignment = "Center";
                                    LINE_1_2.values = [[line.LINE_1_2]];
                                    LINE_1_2_d = sheet.getRange("C7");
                                    LINE_1_2_d.format.fill.color = "#D9D9D9";
                                    LINE_1_2_d.format.font.bold = false;
                                    LINE_1_2_d.format.font.color = "#000000";
                                    LINE_1_2_d.format.font.size = 11;
                                    LINE_1_2_d.format.horizontalAlignment = "Center";
                                    LINE_1_2_d.format.verticalAlignment = "Center";
                                    LINE_1_3 = sheet.getRange("E6");
                                    LINE_1_3.format.fill.color = "#688BBB";
                                    LINE_1_3.format.font.bold = true;
                                    LINE_1_3.format.font.color = "#FFFFFF";
                                    LINE_1_3.format.font.size = 10;
                                    LINE_1_3.format.horizontalAlignment = "Left";
                                    LINE_1_3.format.verticalAlignment = "Center";
                                    LINE_1_3.values = [[line.LINE_1_3]];
                                    LINE_1_3_d = sheet.getRange("E7");
                                    LINE_1_3_d.format.fill.color = "#D9D9D9";
                                    LINE_1_3_d.format.font.bold = false;
                                    LINE_1_3_d.format.font.color = "#000000";
                                    LINE_1_3_d.format.font.size = 11;
                                    LINE_1_3_d.format.horizontalAlignment = "Center";
                                    LINE_1_3_d.format.verticalAlignment = "Center";
                                    LINE_1_4 = sheet.getRange("A9");
                                    LINE_1_4.format.fill.color = "#688BBB";
                                    LINE_1_4.format.font.bold = true;
                                    LINE_1_4.format.font.color = "#FFFFFF";
                                    LINE_1_4.format.font.size = 10;
                                    LINE_1_4.format.horizontalAlignment = "Left";
                                    LINE_1_4.format.verticalAlignment = "Center";
                                    sheet.getRange("A9").values = [[line.LINE_1_4]];
                                    LINE_1_4_d = sheet.getRange("A10:E10");
                                    LINE_1_4_d.merge();
                                    LINE_1_4_d.format.fill.color = "#D9D9D9";
                                    LINE_1_4_d.format.font.bold = false;
                                    LINE_1_4_d.format.font.color = "#000000";
                                    LINE_1_4_d.format.font.size = 11;
                                    LINE_1_4_d.format.horizontalAlignment = "Left";
                                    LINE_1_4_d.format.verticalAlignment = "Center";
                                    LINE_1_5 = sheet.getRange("A12");
                                    LINE_1_5.format.fill.color = "#688BBB";
                                    LINE_1_5.format.font.bold = true;
                                    LINE_1_5.format.font.color = "#FFFFFF";
                                    LINE_1_5.format.font.size = 10;
                                    LINE_1_5.format.horizontalAlignment = "Left";
                                    LINE_1_5.format.verticalAlignment = "Center";
                                    sheet.getRange("A12").values = [[line.LINE_1_5]];
                                    LINE_1_5_d = sheet.getRange("A13:E13");
                                    LINE_1_5_d.merge();
                                    LINE_1_5_d.format.fill.color = "#D9D9D9";
                                    LINE_1_5_d.format.font.bold = false;
                                    LINE_1_5_d.format.font.color = "#000000";
                                    LINE_1_5_d.format.font.size = 11;
                                    LINE_1_5_d.format.horizontalAlignment = "Left";
                                    LINE_1_5_d.format.verticalAlignment = "Center";
                                    LINE_1_6 = sheet.getRange("A15");
                                    LINE_1_6.format.fill.color = "#688BBB";
                                    LINE_1_6.format.font.bold = true;
                                    LINE_1_6.format.font.color = "#FFFFFF";
                                    LINE_1_6.format.font.size = 10;
                                    LINE_1_6.format.horizontalAlignment = "Left";
                                    LINE_1_6.format.verticalAlignment = "Center";
                                    LINE_1_6.values = [[line.LINE_1_6]];
                                    LINE_1_6_d = sheet.getRange("A16");
                                    LINE_1_6_d.format.fill.color = "#D9D9D9";
                                    LINE_1_6_d.format.font.bold = false;
                                    LINE_1_6_d.format.font.color = "#000000";
                                    LINE_1_6_d.format.font.size = 11;
                                    LINE_1_6_d.format.horizontalAlignment = "Center";
                                    LINE_1_6_d.format.verticalAlignment = "Center";
                                    LINE_1_7 = sheet.getRange("C15");
                                    LINE_1_7.format.fill.color = "#688BBB";
                                    LINE_1_7.format.font.bold = true;
                                    LINE_1_7.format.font.color = "#FFFFFF";
                                    LINE_1_7.format.font.size = 10;
                                    LINE_1_7.format.horizontalAlignment = "Left";
                                    LINE_1_7.format.verticalAlignment = "Center";
                                    LINE_1_7.values = [[line.LINE_1_7]];
                                    LINE_1_7_d = sheet.getRange("C16:E16");
                                    LINE_1_7_d.merge();
                                    LINE_1_7_d.format.fill.color = "#D9D9D9";
                                    LINE_1_7_d.format.font.bold = false;
                                    LINE_1_7_d.format.font.color = "#000000";
                                    LINE_1_7_d.format.font.size = 11;
                                    LINE_1_7_d.format.horizontalAlignment = "Left";
                                    LINE_1_7_d.format.verticalAlignment = "Center";
                                    LINE_1_8 = sheet.getRange("A18");
                                    LINE_1_8.format.fill.color = "#688BBB";
                                    LINE_1_8.format.font.bold = true;
                                    LINE_1_8.format.font.color = "#FFFFFF";
                                    LINE_1_8.format.font.size = 10;
                                    LINE_1_8.format.horizontalAlignment = "Left";
                                    LINE_1_8.format.verticalAlignment = "Center";
                                    LINE_1_8.values = [[line.LINE_1_8]];
                                    LINE_1_8_d = sheet.getRange("A19:E19");
                                    LINE_1_8_d.merge();
                                    LINE_1_8_d.format.fill.color = "#D9D9D9";
                                    LINE_1_8_d.format.font.bold = false;
                                    LINE_1_8_d.format.font.color = "#000000";
                                    LINE_1_8_d.format.font.size = 11;
                                    LINE_1_8_d.format.horizontalAlignment = "Left";
                                    LINE_1_8_d.format.verticalAlignment = "Center";
                                    LINE_1_9 = sheet.getRange("A21:E21");
                                    LINE_1_9.merge();
                                    LINE_1_9.format.fill.color = "#688BBB";
                                    LINE_1_9.format.font.bold = true;
                                    LINE_1_9.format.font.color = "#FFFFFF";
                                    LINE_1_9.format.font.size = 10;
                                    LINE_1_9.format.horizontalAlignment = "Left";
                                    LINE_1_9.format.verticalAlignment = "Center";
                                    sheet.getRange("A21").values = [[line.LINE_1_9]];
                                    LINE_1_9_d = sheet.getRange("A22:E22");
                                    LINE_1_9_d.merge();
                                    LINE_1_9_d.format.fill.color = "#D9D9D9";
                                    LINE_1_9_d.format.font.bold = false;
                                    LINE_1_9_d.format.font.color = "#000000";
                                    LINE_1_9_d.format.font.size = 11;
                                    LINE_1_9_d.format.horizontalAlignment = "Left";
                                    LINE_1_9_d.format.verticalAlignment = "Center";
                                    LINE_1_10 = sheet.getRange("A24");
                                    LINE_1_10.format.fill.color = "#688BBB";
                                    LINE_1_10.format.font.bold = true;
                                    LINE_1_10.format.font.color = "#FFFFFF";
                                    LINE_1_10.format.font.size = 10;
                                    LINE_1_10.format.horizontalAlignment = "Left";
                                    LINE_1_10.format.verticalAlignment = "Center";
                                    sheet.getRange("A24").values = [[line.LINE_1_10]];
                                    LINE_1_10_d = sheet.getRange("A25:E25");
                                    LINE_1_10_d.merge();
                                    LINE_1_10_d.format.fill.color = "#D9D9D9";
                                    LINE_1_10_d.format.font.bold = false;
                                    LINE_1_10_d.format.font.color = "#000000";
                                    LINE_1_10_d.format.font.size = 11;
                                    LINE_1_10_d.format.horizontalAlignment = "Left";
                                    LINE_1_10_d.format.verticalAlignment = "Center";
                                    LINE_1_11 = sheet.getRange("A27");
                                    LINE_1_11.format.fill.color = "#688BBB";
                                    LINE_1_11.format.font.bold = true;
                                    LINE_1_11.format.font.color = "#FFFFFF";
                                    LINE_1_11.format.font.size = 10;
                                    LINE_1_11.format.horizontalAlignment = "Left";
                                    LINE_1_11.format.verticalAlignment = "Center";
                                    sheet.getRange("A27").values = [[line.LINE_1_11]];
                                    LINE_1_11_d = sheet.getRange("A28:E28");
                                    LINE_1_11_d.merge();
                                    LINE_1_11_d.format.fill.color = "#D9D9D9";
                                    LINE_1_11_d.format.font.bold = false;
                                    LINE_1_11_d.format.font.color = "#000000";
                                    LINE_1_11_d.format.font.size = 11;
                                    LINE_1_11_d.format.horizontalAlignment = "Left";
                                    LINE_1_11_d.format.verticalAlignment = "Center";
                                    HEADER_2 = sheet.getRange("A30:E30");
                                    HEADER_2.merge();
                                    HEADER_2.format.fill.color = "#FFFFFF";
                                    HEADER_2.format.font.bold = false;
                                    HEADER_2.format.font.color = "#000000";
                                    HEADER_2.format.font.size = 16;
                                    HEADER_2.format.horizontalAlignment = "Left";
                                    HEADER_2.format.verticalAlignment = "Bottom";
                                    sheet.getRange("A30").values = [[headers.HEADER_2]];
                                    LINE_2_1 = sheet.getRange("A31");
                                    LINE_2_1.format.fill.color = "#688BBB";
                                    LINE_2_1.format.font.bold = true;
                                    LINE_2_1.format.font.color = "#FFFFFF";
                                    LINE_2_1.format.font.size = 10;
                                    LINE_2_1.format.horizontalAlignment = "Left";
                                    LINE_2_1.format.verticalAlignment = "Center";
                                    LINE_2_1.values = [[line.LINE_2_1]];
                                    LINE_2_1_d = sheet.getRange("A32");
                                    LINE_2_1_d.format.fill.color = "#D9D9D9";
                                    LINE_2_1_d.format.font.bold = false;
                                    LINE_2_1_d.format.font.color = "#000000";
                                    LINE_2_1_d.format.font.size = 11;
                                    LINE_2_1_d.format.horizontalAlignment = "Center";
                                    LINE_2_1_d.format.verticalAlignment = "Center";
                                    LINE_2_2 = sheet.getRange("C31");
                                    LINE_2_2.format.fill.color = "#688BBB";
                                    LINE_2_2.format.font.bold = true;
                                    LINE_2_2.format.font.color = "#FFFFFF";
                                    LINE_2_2.format.font.size = 10;
                                    LINE_2_2.format.horizontalAlignment = "Left";
                                    LINE_2_2.format.verticalAlignment = "Center";
                                    LINE_2_2.values = [[line.LINE_2_2]];
                                    LINE_2_2_d = sheet.getRange("C32");
                                    LINE_2_2_d.format.fill.color = "#D9D9D9";
                                    LINE_2_2_d.format.font.bold = false;
                                    LINE_2_2_d.format.font.color = "#000000";
                                    LINE_2_2_d.format.font.size = 11;
                                    LINE_2_2_d.format.horizontalAlignment = "Center";
                                    LINE_2_2_d.format.verticalAlignment = "Center";
                                    LINE_2_3 = sheet.getRange("E31");
                                    LINE_2_3.format.fill.color = "#688BBB";
                                    LINE_2_3.format.font.bold = true;
                                    LINE_2_3.format.font.color = "#FFFFFF";
                                    LINE_2_3.format.font.size = 10;
                                    LINE_2_3.format.horizontalAlignment = "Left";
                                    LINE_2_3.format.verticalAlignment = "Center";
                                    LINE_2_3.values = [[line.LINE_2_3]];
                                    LINE_2_3_d = sheet.getRange("E32");
                                    LINE_2_3_d.format.fill.color = "#D9D9D9";
                                    LINE_2_3_d.format.font.bold = false;
                                    LINE_2_3_d.format.font.color = "#000000";
                                    LINE_2_3_d.format.font.size = 11;
                                    LINE_2_3_d.format.horizontalAlignment = "Center";
                                    LINE_2_3_d.format.verticalAlignment = "Center";
                                    LINE_2_4 = sheet.getRange("A34");
                                    LINE_2_4.format.fill.color = "#688BBB";
                                    LINE_2_4.format.font.bold = true;
                                    LINE_2_4.format.font.color = "#FFFFFF";
                                    LINE_2_4.format.font.size = 10;
                                    LINE_2_4.format.horizontalAlignment = "Left";
                                    LINE_2_4.format.verticalAlignment = "Center";
                                    sheet.getRange("A34").values = [[line.LINE_2_4]];
                                    LINE_2_4_d = sheet.getRange("A35:E35");
                                    LINE_2_4_d.merge();
                                    LINE_2_4_d.format.fill.color = "#D9D9D9";
                                    LINE_2_4_d.format.font.bold = false;
                                    LINE_2_4_d.format.font.color = "#000000";
                                    LINE_2_4_d.format.font.size = 11;
                                    LINE_2_4_d.format.horizontalAlignment = "Left";
                                    LINE_2_4_d.format.verticalAlignment = "Center";
                                    LINE_2_5 = sheet.getRange("A37");
                                    LINE_2_5.format.fill.color = "#688BBB";
                                    LINE_2_5.format.font.bold = true;
                                    LINE_2_5.format.font.color = "#FFFFFF";
                                    LINE_2_5.format.font.size = 10;
                                    LINE_2_5.format.horizontalAlignment = "Left";
                                    LINE_2_5.format.verticalAlignment = "Center";
                                    sheet.getRange("A37").values = [[line.LINE_2_5]];
                                    LINE_2_5_d = sheet.getRange("A38:E38");
                                    LINE_2_5_d.merge();
                                    LINE_2_5_d.format.fill.color = "#D9D9D9";
                                    LINE_2_5_d.format.font.bold = false;
                                    LINE_2_5_d.format.font.color = "#000000";
                                    LINE_2_5_d.format.font.size = 11;
                                    LINE_2_5_d.format.horizontalAlignment = "Left";
                                    LINE_2_5_d.format.verticalAlignment = "Center";
                                    HEADER_3 = sheet.getRange("A40:E40");
                                    HEADER_3.merge();
                                    HEADER_3.format.fill.color = "#FFFFFF";
                                    HEADER_3.format.font.bold = false;
                                    HEADER_3.format.font.color = "#000000";
                                    HEADER_3.format.font.size = 16;
                                    HEADER_3.format.horizontalAlignment = "Left";
                                    HEADER_3.format.verticalAlignment = "Bottom";
                                    sheet.getRange("A40").values = [[headers.HEADER_3]];
                                    LINE_3_1 = sheet.getRange("A41");
                                    LINE_3_1.format.fill.color = "#688BBB";
                                    LINE_3_1.format.font.bold = true;
                                    LINE_3_1.format.font.color = "#FFFFFF";
                                    LINE_3_1.format.font.size = 10;
                                    LINE_3_1.format.horizontalAlignment = "Left";
                                    LINE_3_1.format.verticalAlignment = "Center";
                                    LINE_3_1.values = [[line.LINE_3_1]];
                                    LINE_3_1_d = sheet.getRange("A42");
                                    LINE_3_1_d.format.fill.color = "#D9D9D9";
                                    LINE_3_1_d.format.font.bold = false;
                                    LINE_3_1_d.format.font.color = "#000000";
                                    LINE_3_1_d.format.font.size = 11;
                                    LINE_3_1_d.format.horizontalAlignment = "Center";
                                    LINE_3_1_d.format.verticalAlignment = "Center";
                                    LINE_3_2 = sheet.getRange("C41");
                                    LINE_3_2.format.fill.color = "#688BBB";
                                    LINE_3_2.format.font.bold = true;
                                    LINE_3_2.format.font.color = "#FFFFFF";
                                    LINE_3_2.format.font.size = 10;
                                    LINE_3_2.format.horizontalAlignment = "Left";
                                    LINE_3_2.format.verticalAlignment = "Center";
                                    LINE_3_2.values = [[line.LINE_3_2]];
                                    LINE_3_2_d = sheet.getRange("C42");
                                    LINE_3_2_d.format.fill.color = "#D9D9D9";
                                    LINE_3_2_d.format.font.bold = false;
                                    LINE_3_2_d.format.font.color = "#000000";
                                    LINE_3_2_d.format.font.size = 11;
                                    LINE_3_2_d.format.horizontalAlignment = "Center";
                                    LINE_3_2_d.format.verticalAlignment = "Center";
                                    LINE_3_3 = sheet.getRange("E41");
                                    LINE_3_3.format.fill.color = "#688BBB";
                                    LINE_3_3.format.font.bold = true;
                                    LINE_3_3.format.font.color = "#FFFFFF";
                                    LINE_3_3.format.font.size = 10;
                                    LINE_3_3.format.horizontalAlignment = "Left";
                                    LINE_3_3.format.verticalAlignment = "Center";
                                    LINE_3_3.values = [[line.LINE_3_3]];
                                    LINE_3_3_d = sheet.getRange("E42");
                                    LINE_3_3_d.format.fill.color = "#D9D9D9";
                                    LINE_3_3_d.format.font.bold = false;
                                    LINE_3_3_d.format.font.color = "#000000";
                                    LINE_3_3_d.format.font.size = 11;
                                    LINE_3_3_d.format.horizontalAlignment = "Center";
                                    LINE_3_3_d.format.verticalAlignment = "Center";
                                    LINE_3_4 = sheet.getRange("A44");
                                    LINE_3_4.format.fill.color = "#688BBB";
                                    LINE_3_4.format.font.bold = true;
                                    LINE_3_4.format.font.color = "#FFFFFF";
                                    LINE_3_4.format.font.size = 10;
                                    LINE_3_4.format.horizontalAlignment = "Left";
                                    LINE_3_4.format.verticalAlignment = "Center";
                                    sheet.getRange("A44").values = [[line.LINE_3_4]];
                                    LINE_3_4_d = sheet.getRange("A45:E45");
                                    LINE_3_4_d.merge();
                                    LINE_3_4_d.format.fill.color = "#D9D9D9";
                                    LINE_3_4_d.format.font.bold = false;
                                    LINE_3_4_d.format.font.color = "#000000";
                                    LINE_3_4_d.format.font.size = 11;
                                    LINE_3_4_d.format.horizontalAlignment = "Left";
                                    LINE_3_4_d.format.verticalAlignment = "Center";
                                    LINE_3_5 = sheet.getRange("A47");
                                    LINE_3_5.format.fill.color = "#688BBB";
                                    LINE_3_5.format.font.bold = true;
                                    LINE_3_5.format.font.color = "#FFFFFF";
                                    LINE_3_5.format.font.size = 10;
                                    LINE_3_5.format.horizontalAlignment = "Left";
                                    LINE_3_5.format.verticalAlignment = "Center";
                                    sheet.getRange("A47").values = [[line.LINE_3_5]];
                                    LINE_3_5_d = sheet.getRange("A48:E48");
                                    LINE_3_5_d.merge();
                                    LINE_3_5_d.format.fill.color = "#D9D9D9";
                                    LINE_3_5_d.format.font.bold = false;
                                    LINE_3_5_d.format.font.color = "#000000";
                                    LINE_3_5_d.format.font.size = 11;
                                    LINE_3_5_d.format.horizontalAlignment = "Left";
                                    LINE_3_5_d.format.verticalAlignment = "Center";
                                    LINE_3_6 = sheet.getRange("A50");
                                    ;
                                    LINE_3_6.format.fill.color = "#688BBB";
                                    LINE_3_6.format.font.bold = true;
                                    LINE_3_6.format.font.color = "#FFFFFF";
                                    LINE_3_6.format.font.size = 10;
                                    LINE_3_6.format.horizontalAlignment = "Left";
                                    LINE_3_6.format.verticalAlignment = "Center";
                                    sheet.getRange("A50").values = [[line.LINE_3_6]];
                                    LINE_3_6_d = sheet.getRange("A51");
                                    LINE_3_6_d.format.fill.color = "#D9D9D9";
                                    LINE_3_6_d.format.font.bold = false;
                                    LINE_3_6_d.format.font.color = "#000000";
                                    LINE_3_6_d.format.font.size = 11;
                                    LINE_3_6_d.format.horizontalAlignment = "Center";
                                    LINE_3_6_d.format.verticalAlignment = "Center";
                                    LINE_3_7 = sheet.getRange("C50");
                                    LINE_3_7.format.fill.color = "#688BBB";
                                    LINE_3_7.format.font.bold = true;
                                    LINE_3_7.format.font.color = "#FFFFFF";
                                    LINE_3_7.format.font.size = 10;
                                    LINE_3_7.format.horizontalAlignment = "Left";
                                    LINE_3_7.format.verticalAlignment = "Center";
                                    LINE_3_7.values = [[line.LINE_3_7]];
                                    LINE_3_7_d = sheet.getRange("C51:E51");
                                    LINE_3_7_d.merge();
                                    LINE_3_7_d.format.fill.color = "#D9D9D9";
                                    LINE_3_7_d.format.font.bold = false;
                                    LINE_3_7_d.format.font.color = "#000000";
                                    LINE_3_7_d.format.font.size = 11;
                                    LINE_3_7_d.format.horizontalAlignment = "Left";
                                    LINE_3_7_d.format.verticalAlignment = "Center";
                                    LINE_3_8 = sheet.getRange("A53");
                                    ;
                                    LINE_3_8.format.fill.color = "#688BBB";
                                    LINE_3_8.format.font.bold = true;
                                    LINE_3_8.format.font.color = "#FFFFFF";
                                    LINE_3_8.format.font.size = 10;
                                    LINE_3_8.format.horizontalAlignment = "Left";
                                    LINE_3_8.format.verticalAlignment = "Center";
                                    sheet.getRange("A53").values = [[line.LINE_3_8]];
                                    LINE_3_8_d = sheet.getRange("A54:E54");
                                    LINE_3_8_d.merge();
                                    LINE_3_8_d.format.fill.color = "#D9D9D9";
                                    LINE_3_8_d.format.font.bold = false;
                                    LINE_3_8_d.format.font.color = "#000000";
                                    LINE_3_8_d.format.font.size = 11;
                                    LINE_3_8_d.format.horizontalAlignment = "Left";
                                    LINE_3_8_d.format.verticalAlignment = "Center";
                                    HEADER_4 = sheet.getRange("A56:E56");
                                    HEADER_4.merge();
                                    HEADER_4.format.fill.color = "#FFFFFF";
                                    HEADER_4.format.font.bold = false;
                                    HEADER_4.format.font.color = "#000000";
                                    HEADER_4.format.font.size = 16;
                                    HEADER_4.format.horizontalAlignment = "Left";
                                    HEADER_4.format.verticalAlignment = "Bottom";
                                    sheet.getRange("A56").values = [[headers.HEADER_4]];
                                    LINE_4_1 = sheet.getRange("A57");
                                    LINE_4_1.format.fill.color = "#688BBB";
                                    LINE_4_1.format.font.bold = true;
                                    LINE_4_1.format.font.color = "#FFFFFF";
                                    LINE_4_1.format.font.size = 10;
                                    LINE_4_1.format.horizontalAlignment = "Left";
                                    LINE_4_1.format.verticalAlignment = "Center";
                                    LINE_4_1.values = [[line.LINE_4_1]];
                                    LINE_4_1_d = sheet.getRange("A58:E58");
                                    LINE_4_1_d.merge();
                                    LINE_4_1_d.format.fill.color = "#D9D9D9";
                                    LINE_4_1_d.format.font.bold = false;
                                    LINE_4_1_d.format.font.color = "#000000";
                                    LINE_4_1_d.format.font.size = 11;
                                    LINE_4_1_d.format.horizontalAlignment = "Left";
                                    LINE_4_1_d.format.verticalAlignment = "Center";
                                    LINE_4_8 = sheet.getRange("A60");
                                    LINE_4_8.format.fill.color = "#688BBB";
                                    LINE_4_8.format.font.bold = true;
                                    LINE_4_8.format.font.color = "#FFFFFF";
                                    LINE_4_8.format.font.size = 10;
                                    LINE_4_8.format.horizontalAlignment = "Left";
                                    LINE_4_8.format.verticalAlignment = "Center";
                                    LINE_4_8.values = [[line.LINE_4_8]];
                                    LINE_4_8_d = sheet.getRange("A61:E61");
                                    LINE_4_8_d.merge();
                                    LINE_4_8_d.format.fill.color = "#D9D9D9";
                                    LINE_4_8_d.format.font.bold = false;
                                    LINE_4_8_d.format.font.color = "#000000";
                                    LINE_4_8_d.format.font.size = 11;
                                    LINE_4_8_d.format.horizontalAlignment = "Left";
                                    LINE_4_8_d.format.verticalAlignment = "Center";
                                    LINE_4_2 = sheet.getRange("A63");
                                    LINE_4_2.format.fill.color = "#688BBB";
                                    LINE_4_2.format.font.bold = true;
                                    LINE_4_2.format.font.color = "#FFFFFF";
                                    LINE_4_2.format.font.size = 10;
                                    LINE_4_2.format.horizontalAlignment = "Left";
                                    LINE_4_2.format.verticalAlignment = "Center";
                                    LINE_4_2.values = [[line.LINE_4_2]];
                                    LINE_4_2_d = sheet.getRange("A64:E64");
                                    LINE_4_2_d.merge();
                                    LINE_4_2_d.format.fill.color = "#D9D9D9";
                                    LINE_4_2_d.format.font.bold = false;
                                    LINE_4_2_d.format.font.color = "#000000";
                                    LINE_4_2_d.format.font.size = 11;
                                    LINE_4_2_d.format.wrapText = true;
                                    LINE_4_2_d.format.horizontalAlignment = "Left";
                                    LINE_4_2_d.format.verticalAlignment = "Top";
                                    LINE_4_3 = sheet.getRange("A66");
                                    ;
                                    LINE_4_3.format.fill.color = "#688BBB";
                                    LINE_4_3.format.font.bold = true;
                                    LINE_4_3.format.font.color = "#FFFFFF";
                                    LINE_4_3.format.font.size = 10;
                                    LINE_4_3.format.horizontalAlignment = "Left";
                                    LINE_4_3.format.verticalAlignment = "Center";
                                    LINE_4_3.values = [[line.LINE_4_3]];
                                    LINE_4_3_d = sheet.getRange("A67");
                                    LINE_4_3_d.format.fill.color = "#D9D9D9";
                                    LINE_4_3_d.format.font.bold = false;
                                    LINE_4_3_d.format.font.color = "#000000";
                                    LINE_4_3_d.format.font.size = 11;
                                    LINE_4_3_d.format.horizontalAlignment = "Left";
                                    LINE_4_3_d.format.verticalAlignment = "Center";
                                    LINE_4_4 = sheet.getRange("C66");
                                    LINE_4_4.format.fill.color = "#688BBB";
                                    LINE_4_4.format.font.bold = true;
                                    LINE_4_4.format.font.color = "#FFFFFF";
                                    LINE_4_4.format.font.size = 10;
                                    LINE_4_4.format.horizontalAlignment = "Left";
                                    LINE_4_4.format.verticalAlignment = "Center";
                                    LINE_4_4.values = [[line.LINE_4_4]];
                                    LINE_4_4_d = sheet.getRange("C67:E67");
                                    LINE_4_4_d.merge();
                                    LINE_4_4_d.format.fill.color = "#D9D9D9";
                                    LINE_4_4_d.format.font.bold = false;
                                    LINE_4_4_d.format.font.color = "#000000";
                                    LINE_4_4_d.format.font.size = 11;
                                    LINE_4_4_d.format.horizontalAlignment = "Left";
                                    LINE_4_4_d.format.verticalAlignment = "Center";
                                    LINE_4_5 = sheet.getRange("A69");
                                    ;
                                    LINE_4_5.format.fill.color = "#688BBB";
                                    LINE_4_5.format.font.bold = true;
                                    LINE_4_5.format.font.color = "#FFFFFF";
                                    LINE_4_5.format.font.size = 10;
                                    LINE_4_5.format.horizontalAlignment = "Left";
                                    LINE_4_5.format.verticalAlignment = "Center";
                                    LINE_4_5.values = [[line.LINE_4_5]];
                                    LINE_4_5_d = sheet.getRange("A70");
                                    LINE_4_5_d.format.fill.color = "#D9D9D9";
                                    LINE_4_5_d.format.font.bold = false;
                                    LINE_4_5_d.format.font.color = "#000000";
                                    LINE_4_5_d.format.font.size = 11;
                                    LINE_4_5_d.format.horizontalAlignment = "Left";
                                    LINE_4_5_d.format.verticalAlignment = "Center";
                                    LINE_4_6 = sheet.getRange("C69");
                                    LINE_4_6.format.fill.color = "#688BBB";
                                    LINE_4_6.format.font.bold = true;
                                    LINE_4_6.format.font.color = "#FFFFFF";
                                    LINE_4_6.format.font.size = 10;
                                    LINE_4_6.format.horizontalAlignment = "Left";
                                    LINE_4_6.format.verticalAlignment = "Center";
                                    LINE_4_6.values = [[line.LINE_4_6]];
                                    LINE_4_6_d = sheet.getRange("C70:E70");
                                    LINE_4_6_d.merge();
                                    LINE_4_6_d.format.fill.color = "#D9D9D9";
                                    LINE_4_6_d.format.font.bold = false;
                                    LINE_4_6_d.format.font.color = "#000000";
                                    LINE_4_6_d.format.font.size = 11;
                                    LINE_4_6_d.format.horizontalAlignment = "Left";
                                    LINE_4_6_d.format.verticalAlignment = "Center";
                                    LINE_4_7 = sheet.getRange("A72");
                                    ;
                                    LINE_4_7.format.fill.color = "#688BBB";
                                    LINE_4_7.format.font.bold = true;
                                    LINE_4_7.format.font.color = "#FFFFFF";
                                    LINE_4_7.format.font.size = 10;
                                    LINE_4_7.format.horizontalAlignment = "Left";
                                    LINE_4_7.format.verticalAlignment = "Center";
                                    LINE_4_7.values = [[line.LINE_4_7]];
                                    LINE_4_7_d = sheet.getRange("A73");
                                    LINE_4_7_d.format.fill.color = "#D9D9D9";
                                    LINE_4_7_d.format.font.bold = false;
                                    LINE_4_7_d.format.font.color = "#000000";
                                    LINE_4_7_d.format.font.size = 11;
                                    LINE_4_7_d.format.horizontalAlignment = "Center";
                                    LINE_4_7_d.format.verticalAlignment = "Center";
                                    HEADER_5 = sheet.getRange("A75:E75");
                                    HEADER_5.merge();
                                    HEADER_5.format.fill.color = "#FFFFFF";
                                    HEADER_5.format.font.bold = false;
                                    HEADER_5.format.font.color = "#000000";
                                    HEADER_5.format.font.size = 16;
                                    HEADER_5.format.horizontalAlignment = "Left";
                                    HEADER_5.format.verticalAlignment = "Bottom";
                                    sheet.getRange("A75").values = [[headers.HEADER_5]];
                                    LINE_5_1 = sheet.getRange("A76");
                                    LINE_5_1.format.fill.color = "#688BBB";
                                    LINE_5_1.format.font.bold = true;
                                    LINE_5_1.format.font.color = "#FFFFFF";
                                    LINE_5_1.format.font.size = 10;
                                    LINE_5_1.format.horizontalAlignment = "Left";
                                    LINE_5_1.format.verticalAlignment = "Center";
                                    LINE_5_1.values = [[line.LINE_5_1]];
                                    LINE_5_1_d = sheet.getRange("A77:E77");
                                    LINE_5_1_d.merge();
                                    LINE_5_1_d.format.fill.color = "#D9D9D9";
                                    LINE_5_1_d.format.font.bold = false;
                                    LINE_5_1_d.format.font.color = "#000000";
                                    LINE_5_1_d.format.font.size = 11;
                                    LINE_5_1_d.format.horizontalAlignment = "Left";
                                    LINE_5_1_d.format.verticalAlignment = "Center";
                                    LINE_5_2 = sheet.getRange("A79");
                                    ;
                                    LINE_5_2.format.fill.color = "#688BBB";
                                    LINE_5_2.format.font.bold = true;
                                    LINE_5_2.format.font.color = "#FFFFFF";
                                    LINE_5_2.format.font.size = 10;
                                    LINE_5_2.format.horizontalAlignment = "Left";
                                    LINE_5_2.format.verticalAlignment = "Center";
                                    LINE_5_2.values = [[line.LINE_5_2]];
                                    LINE_5_2_d = sheet.getRange("A80");
                                    LINE_5_2_d.format.fill.color = "#D9D9D9";
                                    LINE_5_2_d.format.font.bold = false;
                                    LINE_5_2_d.format.font.color = "#000000";
                                    LINE_5_2_d.format.font.size = 11;
                                    LINE_5_2_d.format.horizontalAlignment = "Center";
                                    LINE_5_2_d.format.verticalAlignment = "Center";
                                    LINE_5_3 = sheet.getRange("C79");
                                    LINE_5_3.format.fill.color = "#688BBB";
                                    LINE_5_3.format.font.bold = true;
                                    LINE_5_3.format.font.color = "#FFFFFF";
                                    LINE_5_3.format.font.size = 10;
                                    LINE_5_3.format.horizontalAlignment = "Left";
                                    LINE_5_3.format.verticalAlignment = "Center";
                                    LINE_5_3.values = [[line.LINE_5_3]];
                                    LINE_5_3_d = sheet.getRange("C80");
                                    LINE_5_3_d.format.fill.color = "#D9D9D9";
                                    LINE_5_3_d.format.font.bold = false;
                                    LINE_5_3_d.format.font.color = "#000000";
                                    LINE_5_3_d.format.font.size = 11;
                                    LINE_5_3_d.format.horizontalAlignment = "Center";
                                    LINE_5_3_d.format.verticalAlignment = "Center";
                                    LINE_5_4 = sheet.getRange("A82");
                                    LINE_5_4.format.fill.color = "#688BBB";
                                    LINE_5_4.format.font.bold = true;
                                    LINE_5_4.format.font.color = "#FFFFFF";
                                    LINE_5_4.format.font.size = 10;
                                    LINE_5_4.format.horizontalAlignment = "Left";
                                    LINE_5_4.format.verticalAlignment = "Center";
                                    LINE_5_4.values = [[line.LINE_5_4]];
                                    LINE_5_4_d = sheet.getRange("A83");
                                    LINE_5_4_d.format.fill.color = "#D9D9D9";
                                    LINE_5_4_d.format.font.bold = false;
                                    LINE_5_4_d.format.font.color = "#000000";
                                    LINE_5_4_d.format.font.size = 11;
                                    LINE_5_4_d.format.horizontalAlignment = "Center";
                                    LINE_5_4_d.format.verticalAlignment = "Center";
                                    LINE_5_5 = sheet.getRange("C82");
                                    LINE_5_5.format.fill.color = "#688BBB";
                                    LINE_5_5.format.font.bold = true;
                                    LINE_5_5.format.font.color = "#FFFFFF";
                                    LINE_5_5.format.font.size = 10;
                                    LINE_5_5.format.horizontalAlignment = "Left";
                                    LINE_5_5.format.verticalAlignment = "Center";
                                    LINE_5_5.values = [[line.LINE_5_5]];
                                    LINE_5_5_d = sheet.getRange("C83");
                                    LINE_5_5_d.format.fill.color = "#D9D9D9";
                                    LINE_5_5_d.format.font.bold = false;
                                    LINE_5_5_d.format.font.color = "#000000";
                                    LINE_5_5_d.format.font.size = 11;
                                    LINE_5_5_d.format.horizontalAlignment = "Center";
                                    LINE_5_5_d.format.verticalAlignment = "Center";
                                    HEADER_6 = sheet.getRange("A85:E85");
                                    HEADER_6.merge();
                                    HEADER_6.format.fill.color = "#FFFFFF";
                                    HEADER_6.format.font.bold = false;
                                    HEADER_6.format.font.color = "#000000";
                                    HEADER_6.format.font.size = 16;
                                    HEADER_6.format.horizontalAlignment = "Left";
                                    HEADER_6.format.verticalAlignment = "Bottom";
                                    sheet.getRange("A85").values = [[headers.HEADER_6]];
                                    LINE_6_1 = sheet.getRange("A86");
                                    LINE_6_1.format.fill.color = "#688BBB";
                                    LINE_6_1.format.font.bold = true;
                                    LINE_6_1.format.font.color = "#FFFFFF";
                                    LINE_6_1.format.font.size = 10;
                                    LINE_6_1.format.horizontalAlignment = "Left";
                                    LINE_6_1.format.verticalAlignment = "Center";
                                    LINE_6_1.values = [[line.LINE_6_1]];
                                    LINE_6_1_d = sheet.getRange("A87");
                                    LINE_6_1_d.format.fill.color = "#D9D9D9";
                                    LINE_6_1_d.format.font.bold = false;
                                    LINE_6_1_d.format.font.color = "#000000";
                                    LINE_6_1_d.format.font.size = 11;
                                    LINE_6_1_d.format.horizontalAlignment = "Center";
                                    LINE_6_1_d.format.verticalAlignment = "Center";
                                    LINE_6_2 = sheet.getRange("C86");
                                    LINE_6_2.format.fill.color = "#688BBB";
                                    LINE_6_2.format.font.bold = true;
                                    LINE_6_2.format.font.color = "#FFFFFF";
                                    LINE_6_2.format.font.size = 10;
                                    LINE_6_2.format.horizontalAlignment = "Left";
                                    LINE_6_2.format.verticalAlignment = "Center";
                                    LINE_6_2.values = [[line.LINE_6_2]];
                                    LINE_6_2_d = sheet.getRange("C87");
                                    LINE_6_2_d.format.fill.color = "#D9D9D9";
                                    LINE_6_2_d.format.font.bold = false;
                                    LINE_6_2_d.format.font.color = "#000000";
                                    LINE_6_2_d.format.font.size = 11;
                                    LINE_6_2_d.format.horizontalAlignment = "Center";
                                    LINE_6_2_d.format.verticalAlignment = "Center";
                                    LINE_6_3 = sheet.getRange("E86");
                                    LINE_6_3.format.fill.color = "#688BBB";
                                    LINE_6_3.format.font.bold = true;
                                    LINE_6_3.format.font.color = "#FFFFFF";
                                    LINE_6_3.format.font.size = 10;
                                    LINE_6_3.format.horizontalAlignment = "Left";
                                    LINE_6_3.format.verticalAlignment = "Center";
                                    LINE_6_3.values = [[line.LINE_6_3]];
                                    LINE_6_3_d = sheet.getRange("E87");
                                    LINE_6_3_d.format.fill.color = "#D9D9D9";
                                    LINE_6_3_d.format.font.bold = false;
                                    LINE_6_3_d.format.font.color = "#000000";
                                    LINE_6_3_d.format.font.size = 11;
                                    LINE_6_3_d.format.horizontalAlignment = "Center";
                                    LINE_6_3_d.format.verticalAlignment = "Center";
                                    LINE_6_4 = sheet.getRange("A89");
                                    LINE_6_4.format.fill.color = "#688BBB";
                                    LINE_6_4.format.font.bold = true;
                                    LINE_6_4.format.font.color = "#FFFFFF";
                                    LINE_6_4.format.font.size = 10;
                                    LINE_6_4.format.horizontalAlignment = "Left";
                                    LINE_6_4.format.verticalAlignment = "Center";
                                    LINE_6_4.values = [[line.LINE_6_4]];
                                    LINE_6_4_d = sheet.getRange("A90:E90");
                                    LINE_6_4_d.merge();
                                    LINE_6_4_d.format.fill.color = "#D9D9D9";
                                    LINE_6_4_d.format.font.bold = false;
                                    LINE_6_4_d.format.font.color = "#000000";
                                    LINE_6_4_d.format.font.size = 11;
                                    LINE_6_4_d.format.wrapText = true;
                                    LINE_6_4_d.format.horizontalAlignment = "Left";
                                    LINE_6_4_d.format.verticalAlignment = "Center";
                                    HEADER_7 = sheet.getRange("A92:E92");
                                    HEADER_7.merge();
                                    HEADER_7.format.fill.color = "#FFFFFF";
                                    HEADER_7.format.font.bold = false;
                                    HEADER_7.format.font.color = "#000000";
                                    HEADER_7.format.font.size = 16;
                                    HEADER_7.format.horizontalAlignment = "Left";
                                    HEADER_7.format.verticalAlignment = "Bottom";
                                    sheet.getRange("A92").values = [[headers.HEADER_7]];
                                    HEADER_7A = sheet.getRange("A93:E93");
                                    HEADER_7A.merge();
                                    HEADER_7A.format.fill.color = "#FFFFFF";
                                    HEADER_7A.format.font.bold = false;
                                    HEADER_7A.format.font.color = "#000000";
                                    HEADER_7A.format.font.size = 14;
                                    HEADER_7A.format.horizontalAlignment = "Left";
                                    HEADER_7A.format.verticalAlignment = "Center";
                                    sheet.getRange("A93").values = [[headers.HEADER_7A]];
                                    LINE_7A_1 = sheet.getRange("A94");
                                    LINE_7A_1.format.fill.color = "#688BBB";
                                    LINE_7A_1.format.font.bold = true;
                                    LINE_7A_1.format.font.color = "#FFFFFF";
                                    LINE_7A_1.format.font.size = 11;
                                    LINE_7A_1.format.horizontalAlignment = "Left";
                                    LINE_7A_1.format.verticalAlignment = "Center";
                                    sheet.getRange("A94").values = [[line.LINE_7A_1]];
                                    LINE_7A_1_d = sheet.getRange("A95");
                                    LINE_7A_1_d.format.fill.color = "#D9D9D9";
                                    LINE_7A_1_d.format.font.bold = false;
                                    LINE_7A_1_d.format.font.color = "#000000";
                                    LINE_7A_1_d.format.font.size = 11;
                                    LINE_7A_1_d.format.horizontalAlignment = "Left";
                                    LINE_7A_1_d.format.verticalAlignment = "Center";
                                    LINE_7A_2 = sheet.getRange("C94");
                                    LINE_7A_2.format.fill.color = "#688BBB";
                                    LINE_7A_2.format.font.bold = true;
                                    LINE_7A_2.format.font.color = "#FFFFFF";
                                    LINE_7A_2.format.font.size = 11;
                                    LINE_7A_2.format.horizontalAlignment = "Left";
                                    LINE_7A_2.format.verticalAlignment = "Center";
                                    LINE_7A_2.values = [[line.LINE_7A_2]];
                                    LINE_7A_2_d = sheet.getRange("C95");
                                    LINE_7A_2_d.format.fill.color = "#D9D9D9";
                                    LINE_7A_2_d.format.font.bold = false;
                                    LINE_7A_2_d.format.font.color = "#000000";
                                    LINE_7A_2_d.format.font.size = 11;
                                    LINE_7A_2_d.format.horizontalAlignment = "Center";
                                    LINE_7A_2_d.format.verticalAlignment = "Center";
                                    LINE_7A_3 = sheet.getRange("E94");
                                    LINE_7A_3.format.fill.color = "#688BBB";
                                    LINE_7A_3.format.font.bold = true;
                                    LINE_7A_3.format.font.color = "#FFFFFF";
                                    LINE_7A_3.format.font.size = 11;
                                    LINE_7A_3.format.horizontalAlignment = "Left";
                                    LINE_7A_3.format.verticalAlignment = "Center";
                                    LINE_7A_3.values = [[line.LINE_7A_3]];
                                    LINE_7A_3_d = sheet.getRange("E95");
                                    LINE_7A_3_d.format.fill.color = "#D9D9D9";
                                    LINE_7A_3_d.format.font.bold = false;
                                    LINE_7A_3_d.format.font.color = "#000000";
                                    LINE_7A_3_d.format.font.size = 11;
                                    LINE_7A_3_d.format.horizontalAlignment = "Center";
                                    LINE_7A_3_d.format.verticalAlignment = "Center";
                                    HEADER_7B = sheet.getRange("A97:E97");
                                    HEADER_7B.merge();
                                    HEADER_7B.format.fill.color = "#FFFFFF";
                                    HEADER_7B.format.font.bold = false;
                                    HEADER_7B.format.font.color = "#000000";
                                    HEADER_7B.format.font.size = 14;
                                    HEADER_7B.format.horizontalAlignment = "Left";
                                    HEADER_7B.format.verticalAlignment = "Center";
                                    sheet.getRange("A97").values = [[headers.HEADER_7C]];
                                    LINE_7B_1 = sheet.getRange("A98");
                                    LINE_7B_1.format.fill.color = "#688BBB";
                                    LINE_7B_1.format.font.bold = true;
                                    LINE_7B_1.format.font.color = "#FFFFFF";
                                    LINE_7B_1.format.font.size = 11;
                                    LINE_7B_1.format.horizontalAlignment = "Left";
                                    LINE_7B_1.format.verticalAlignment = "Center";
                                    LINE_7B_1.values = [[line.LINE_7C_1]];
                                    LINE_7B_1_d = sheet.getRange("A99");
                                    LINE_7B_1_d.format.fill.color = "#D9D9D9";
                                    LINE_7B_1_d.format.font.bold = false;
                                    LINE_7B_1_d.format.font.color = "#000000";
                                    LINE_7B_1_d.format.font.size = 11;
                                    LINE_7B_1_d.format.horizontalAlignment = "Left";
                                    LINE_7B_1_d.format.verticalAlignment = "Center";
                                    LINE_7B_2 = sheet.getRange("C98");
                                    LINE_7B_2.format.fill.color = "#688BBB";
                                    LINE_7B_2.format.font.bold = true;
                                    LINE_7B_2.format.font.color = "#FFFFFF";
                                    LINE_7B_2.format.font.size = 11;
                                    LINE_7B_2.format.horizontalAlignment = "Left";
                                    LINE_7B_2.format.verticalAlignment = "Center";
                                    LINE_7B_2.values = [[line.LINE_7C_2]];
                                    LINE_7B_2_d = sheet.getRange("C99");
                                    LINE_7B_2_d.format.fill.color = "#D9D9D9";
                                    LINE_7B_2_d.format.font.bold = false;
                                    LINE_7B_2_d.format.font.color = "#000000";
                                    LINE_7B_2_d.format.font.size = 11;
                                    LINE_7B_2_d.format.horizontalAlignment = "Center";
                                    LINE_7B_2_d.format.verticalAlignment = "Center";
                                    LINE_7B_3 = sheet.getRange("E98");
                                    LINE_7B_3.format.fill.color = "#688BBB";
                                    LINE_7B_3.format.font.bold = true;
                                    LINE_7B_3.format.font.color = "#FFFFFF";
                                    LINE_7B_3.format.font.size = 11;
                                    LINE_7B_3.format.horizontalAlignment = "Left";
                                    LINE_7B_3.format.verticalAlignment = "Center";
                                    LINE_7B_3.values = [[line.LINE_7C_3]];
                                    LINE_7B_3_d = sheet.getRange("E99");
                                    LINE_7B_3_d.format.fill.color = "#D9D9D9";
                                    LINE_7B_3_d.format.font.bold = false;
                                    LINE_7B_3_d.format.font.color = "#000000";
                                    LINE_7B_3_d.format.font.size = 11;
                                    LINE_7B_3_d.format.horizontalAlignment = "Center";
                                    LINE_7B_3_d.format.verticalAlignment = "Center";
                                    HEADER_7C = sheet.getRange("A101:E101");
                                    HEADER_7C.merge();
                                    HEADER_7C.format.fill.color = "#FFFFFF";
                                    HEADER_7C.format.font.bold = false;
                                    HEADER_7C.format.font.color = "#000000";
                                    HEADER_7C.format.font.size = 14;
                                    HEADER_7C.format.horizontalAlignment = "Left";
                                    HEADER_7C.format.verticalAlignment = "Center";
                                    sheet.getRange("A101").values = [[headers.HEADER_7B]];
                                    LINE_7C_1 = sheet.getRange("A102");
                                    ;
                                    LINE_7C_1.format.fill.color = "#688BBB";
                                    LINE_7C_1.format.font.bold = true;
                                    LINE_7C_1.format.font.color = "#FFFFFF";
                                    LINE_7C_1.format.font.size = 11;
                                    LINE_7C_1.format.horizontalAlignment = "Left";
                                    LINE_7C_1.format.verticalAlignment = "Center";
                                    LINE_7C_1.values = [[line.LINE_7B_1]];
                                    LINE_7C_1_d = sheet.getRange("A103");
                                    LINE_7C_1_d.format.fill.color = "#D9D9D9";
                                    LINE_7C_1_d.format.font.bold = false;
                                    LINE_7C_1_d.format.font.color = "#000000";
                                    LINE_7C_1_d.format.font.size = 11;
                                    LINE_7C_1_d.format.horizontalAlignment = "Left";
                                    LINE_7C_1_d.format.verticalAlignment = "Center";
                                    LINE_7C_2 = sheet.getRange("C102");
                                    LINE_7C_2.format.fill.color = "#688BBB";
                                    LINE_7C_2.format.font.bold = true;
                                    LINE_7C_2.format.font.color = "#FFFFFF";
                                    LINE_7C_2.format.font.size = 11;
                                    LINE_7C_2.format.horizontalAlignment = "Left";
                                    LINE_7C_2.format.verticalAlignment = "Center";
                                    LINE_7C_2.values = [[line.LINE_7B_2]];
                                    LINE_7C_2_d = sheet.getRange("C103");
                                    LINE_7C_2_d.format.fill.color = "#D9D9D9";
                                    LINE_7C_2_d.format.font.bold = false;
                                    LINE_7C_2_d.format.font.color = "#000000";
                                    LINE_7C_2_d.format.font.size = 11;
                                    LINE_7C_2_d.format.horizontalAlignment = "Center";
                                    LINE_7C_2_d.format.verticalAlignment = "Center";
                                    LINE_7C_3 = sheet.getRange("E102");
                                    LINE_7C_3.format.fill.color = "#688BBB";
                                    LINE_7C_3.format.font.bold = true;
                                    LINE_7C_3.format.font.color = "#FFFFFF";
                                    LINE_7C_3.format.font.size = 11;
                                    LINE_7C_3.format.horizontalAlignment = "Left";
                                    LINE_7C_3.format.verticalAlignment = "Center";
                                    LINE_7C_3.values = [[line.LINE_7B_3]];
                                    LINE_7C_3_d = sheet.getRange("E103");
                                    LINE_7C_3_d.format.fill.color = "#D9D9D9";
                                    LINE_7C_3_d.format.font.bold = false;
                                    LINE_7C_3_d.format.font.color = "#000000";
                                    LINE_7C_3_d.format.font.size = 11;
                                    LINE_7C_3_d.format.horizontalAlignment = "Center";
                                    LINE_7C_3_d.format.verticalAlignment = "Center";
                                    HEADER_8 = sheet.getRange("A105:E105");
                                    HEADER_8.merge();
                                    HEADER_8.format.fill.color = "#FFFFFF";
                                    HEADER_8.format.font.bold = false;
                                    HEADER_8.format.font.color = "#000000";
                                    HEADER_8.format.font.size = 16;
                                    HEADER_8.format.horizontalAlignment = "Left";
                                    HEADER_8.format.verticalAlignment = "Bottom";
                                    sheet.getRange("A105").values = [[headers.HEADER_8]];
                                    LINE_8_1 = sheet.getRange("A106");
                                    LINE_8_1.format.fill.color = "#688BBB";
                                    LINE_8_1.format.font.bold = true;
                                    LINE_8_1.format.font.color = "#FFFFFF";
                                    LINE_8_1.format.font.size = 10;
                                    LINE_8_1.format.horizontalAlignment = "Left";
                                    LINE_8_1.format.verticalAlignment = "Center";
                                    LINE_8_1.values = [[line.LINE_8_1]];
                                    LINE_8_1_d = sheet.getRange("A107:E107");
                                    LINE_8_1_d.merge();
                                    LINE_8_1_d.format.fill.color = "#D9D9D9";
                                    LINE_8_1_d.format.font.bold = false;
                                    LINE_8_1_d.format.font.color = "#000000";
                                    LINE_8_1_d.format.font.size = 11;
                                    LINE_8_1_d.format.wrapText = true;
                                    LINE_8_1_d.format.horizontalAlignment = "Left";
                                    LINE_8_1_d.format.verticalAlignment = "Top";
                                    return [4 /*yield*/, context.sync()];
                                case 4:
                                    _a.sent();
                                    trialRow = 108 + 2;
                                    return [4 /*yield*/, (0, common_1.insertTrialNoticeRow)(sheet, "A".concat(trialRow, ":E").concat(trialRow), eupType.isTrial)];
                                case 5:
                                    _a.sent();
                                    copyrightRow = 108 + 3;
                                    return [4 /*yield*/, (0, common_1.insertCopyrightRow)(sheet, "A".concat(copyrightRow, ":E").concat(copyrightRow))];
                                case 6:
                                    _a.sent();
                                    // Aktywuj arkusz     
                                    sheet.getRange("C4").select();
                                    sheet.activate();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Metoda insertKpoPrintData wstawia dane do arkusza wydruku karty KPO pobrane z obiektu KpoCardPrint
 * @param sheetName Nazwa arkusza
 * @param kpoPrintData Obiekt KpoCardPrint zawierający dane do wydruku karty KPO
 */
function insertKpoPrintData(sheetName, kpoPrintData) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Excel.run(function (context) { return __awaiter(_this, void 0, void 0, function () {
                        var sheet, color, wasteGeneratedTerytPk;
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28;
                        return __generator(this, function (_29) {
                            switch (_29.label) {
                                case 0:
                                    sheet = context.workbook.worksheets.getItem(sheetName);
                                    // SEKCJA 0 - Nagłówek karty
                                    sheet.getRange("A4").values = [[(_a = kpoPrintData.calendarYear) !== null && _a !== void 0 ? _a : ""]];
                                    sheet.getRange("C4").values = [[(_b = kpoPrintData.cardNumber) !== null && _b !== void 0 ? _b : ""]];
                                    sheet.getRange("E4").values = [[(_c = kpoPrintData.cardStatus) !== null && _c !== void 0 ? _c : ""]];
                                    color = "#D9D9D9";
                                    switch (kpoPrintData.cardStatus) {
                                        case "Potwierdzenie transportu":
                                            color = "#B5E6A1";
                                            break;
                                        case "Potwierdzenie przejęcia":
                                            color = "#E5EEF9";
                                            break;
                                        case "Planowana":
                                            color = "#F7F7D8";
                                            break;
                                        case "Zatwierdzona":
                                            color = "#DDF8DB";
                                            break;
                                        case "Potwierdzenie wygenerowane":
                                            color = "#F0E0C2";
                                            break;
                                        case "Wycofana":
                                            color = "#FBE5EA";
                                            break;
                                        case "Odrzucona":
                                            color = "#FF8F6F";
                                            break;
                                    }
                                    sheet.getRange("E4").format.fill.color = color;
                                    // SEKCJA 1 - Dane przekazującego odpady (Sender)
                                    sheet.getRange("A7").numberFormat = [["@"]]; // Format komórki: Text
                                    sheet.getRange("A7").values = [[(_d = kpoPrintData.senderIdentificationNumber) !== null && _d !== void 0 ? _d : ""]]; // Format komórki: Text
                                    sheet.getRange("C7").values = [[(_e = kpoPrintData.senderNip) !== null && _e !== void 0 ? _e : ""]];
                                    sheet.getRange("E7").values = [[(_f = kpoPrintData.senderNipEu) !== null && _f !== void 0 ? _f : ""]];
                                    sheet.getRange("A10").values = [[(_g = kpoPrintData.senderNameOrFirstNameAndLastName) !== null && _g !== void 0 ? _g : ""]];
                                    sheet.getRange("A13").values = [[(_h = kpoPrintData.senderAddress) !== null && _h !== void 0 ? _h : ""]];
                                    sheet.getRange("A16").values = [[(_j = kpoPrintData.senderEupNumber) !== null && _j !== void 0 ? _j : ""]];
                                    sheet.getRange("C16").values = [[(_k = kpoPrintData.senderEupName) !== null && _k !== void 0 ? _k : ""]];
                                    sheet.getRange("A19").values = [[(_l = kpoPrintData.senderEupAddress) !== null && _l !== void 0 ? _l : ""]];
                                    // isWasteGenerating = false lub null wpisz 'Nie', true wposz 'Tak'
                                    sheet.getRange("A22").values = [[kpoPrintData.isWasteGenerating ? "Tak" : "Nie"]];
                                    wasteGeneratedTerytPk = ((_m = kpoPrintData.wasteGeneratedTerytPk) !== null && _m !== void 0 ? _m : "") + " " + ((_o = kpoPrintData.wasteGeneratedDistrict) !== null && _o !== void 0 ? _o : "") + " " + ((_p = kpoPrintData.wasteGeneratedProvince) !== null && _p !== void 0 ? _p : "") + " " + ((_q = kpoPrintData.wasteGeneratedCommune) !== null && _q !== void 0 ? _q : "");
                                    sheet.getRange("A25").values = [[wasteGeneratedTerytPk !== null && wasteGeneratedTerytPk !== void 0 ? wasteGeneratedTerytPk : ""]];
                                    sheet.getRange("A28").values = [[(_r = kpoPrintData.wasteGeneratingAdditionalInfo) !== null && _r !== void 0 ? _r : ""]];
                                    // SEKCJA 2 - Dane transportującego odpady (Carrier) - wymaga dodania komórek w kpoCardPrintSheet
                                    // carrierIdentificationNumber, carrierNip, carrierNipEu, carrierNameOrFirstNameAndLastName, carrierAddress
                                    sheet.getRange("A32").numberFormat = [["@"]]; // Format komórki: Text
                                    sheet.getRange("A32").values = [[(_s = kpoPrintData.carrierIdentificationNumber) !== null && _s !== void 0 ? _s : ""]];
                                    sheet.getRange("C32").values = [[(_t = kpoPrintData.carrierNip) !== null && _t !== void 0 ? _t : ""]];
                                    sheet.getRange("E32").values = [[(_u = kpoPrintData.carrierNipEu) !== null && _u !== void 0 ? _u : ""]];
                                    sheet.getRange("A35").values = [[(_v = kpoPrintData.carrierNameOrFirstNameAndLastName) !== null && _v !== void 0 ? _v : ""]];
                                    sheet.getRange("A38").values = [[(_w = kpoPrintData.carrierAddress) !== null && _w !== void 0 ? _w : ""]];
                                    // SEKCJA 3 - Dane przejmującego odpady (Receiver) - wymaga dodania komórek w kpoCardPrintSheet  
                                    // receiverIdentificationNumber, receiverNip, receiverNipEu, receiverNameOrFirstNameAndLastName, receiverAddress
                                    // receiverEupNumber, receiverEupName, receiverEupAddress
                                    sheet.getRange("A42").numberFormat = [["@"]]; // Format komórki: Text
                                    sheet.getRange("A42").values = [[(_x = kpoPrintData.receiverIdentificationNumber) !== null && _x !== void 0 ? _x : ""]];
                                    sheet.getRange("C42").values = [[(_y = kpoPrintData.receiverNip) !== null && _y !== void 0 ? _y : ""]];
                                    sheet.getRange("E42").values = [[(_z = kpoPrintData.receiverNipEu) !== null && _z !== void 0 ? _z : ""]];
                                    sheet.getRange("A45").values = [[(_0 = kpoPrintData.receiverNameOrFirstNameAndLastName) !== null && _0 !== void 0 ? _0 : ""]];
                                    sheet.getRange("A48").values = [[(_1 = kpoPrintData.receiverAddress) !== null && _1 !== void 0 ? _1 : ""]];
                                    sheet.getRange("A51").values = [[(_2 = kpoPrintData.receiverEupNumber) !== null && _2 !== void 0 ? _2 : ""]];
                                    sheet.getRange("C51").values = [[(_3 = kpoPrintData.receiverEupName) !== null && _3 !== void 0 ? _3 : ""]];
                                    sheet.getRange("A54").values = [[(_4 = kpoPrintData.receiverEupAddress) !== null && _4 !== void 0 ? _4 : ""]];
                                    // SEKCJA 4 - Informacje dotyczące odpadów - wymaga dodania komórek w kpoCardPrintSheet
                                    // wasteCodeAndDescription, wasteMass, correctedWasteMass, certificateNumber, wasteProcess, wasteProcessWithCode
                                    // wasteCodeExtended, wasteCodeExtendedDescription, hazardousWasteReclassification, hazardousWasteReclassificationDescription
                                    sheet.getRange("A58").values = [[(_5 = kpoPrintData.wasteProcessWithCode) !== null && _5 !== void 0 ? _5 : ""]];
                                    sheet.getRange("A64").values = [[(_6 = kpoPrintData.wasteCodeAndDescription) !== null && _6 !== void 0 ? _6 : ""]];
                                    sheet.getRange("A67").values = [[kpoPrintData.wasteCodeExtended ? "Tak" : "Nie"]];
                                    sheet.getRange("C67").values = [[(_7 = kpoPrintData.wasteCodeExtendedDescription) !== null && _7 !== void 0 ? _7 : ""]];
                                    sheet.getRange("A70").values = [[kpoPrintData.hazardousWasteReclassification ? "Tak" : "Nie"]];
                                    sheet.getRange("C70").values = [[(_8 = kpoPrintData.hazardousWasteReclassificationDescription) !== null && _8 !== void 0 ? _8 : ""]];
                                    sheet.getRange("A73").numberFormat = [["0.0000"]];
                                    sheet.getRange("A73").values = [[(_9 = kpoPrintData.wasteMass) !== null && _9 !== void 0 ? _9 : ""]];
                                    //sheet.getRange("A61").values = [[kpoPrintData.certificateNumber ?? ""]];
                                    //sheet.getRange("C73").numberFormat = [["0.0000"]];
                                    //sheet.getRange("C73").values = [[kpoPrintData.correctedWasteMass ?? ""]];
                                    // E73 róźnica wasteMass - correctedWasteMass
                                    //sheet.getRange("E73").numberFormat = [["0.0000"]];
                                    //sheet.getRange("E73").values = [[kpoPrintData.wasteMass && kpoPrintData.correctedWasteMass ? (parseFloat(kpoPrintData.wasteMass) - parseFloat(kpoPrintData.correctedWasteMass)).toString() : "0"]];
                                    // SEKCJA 5 - Informacje dotyczące transportu odpadów
                                    // vehicleRegNumber, plannedTransportDate, plannedTransportTime, realTransportDate, realTransportTime
                                    sheet.getRange("A77").values = [[(_10 = kpoPrintData.vehicleRegNumber) !== null && _10 !== void 0 ? _10 : ""]];
                                    sheet.getRange("A80").values = [[(_11 = kpoPrintData.plannedTransportDate) !== null && _11 !== void 0 ? _11 : ""]];
                                    sheet.getRange("C80").values = [[(_12 = kpoPrintData.plannedTransportTime) !== null && _12 !== void 0 ? _12 : ""]];
                                    sheet.getRange("A83").values = [[(_13 = kpoPrintData.realTransportDate) !== null && _13 !== void 0 ? _13 : ""]];
                                    sheet.getRange("C83").values = [[(_14 = kpoPrintData.realTransportTime) !== null && _14 !== void 0 ? _14 : ""]];
                                    // SEKCJA 6 - Informacje dotyczące przejęcia odpadów
                                    sheet.getRange("A87").numberFormat = [["0.0000"]];
                                    sheet.getRange("A87").values = [[(_15 = kpoPrintData.correctedWasteMass) !== null && _15 !== void 0 ? _15 : ""]];
                                    sheet.getRange("C87").values = [[(_16 = kpoPrintData.receiveConfirmationDate) !== null && _16 !== void 0 ? _16 : ""]];
                                    sheet.getRange("E87").values = [[(_17 = kpoPrintData.receiveConfirmationTime) !== null && _17 !== void 0 ? _17 : ""]];
                                    sheet.getRange("A90").values = [[(_18 = kpoPrintData.remarks) !== null && _18 !== void 0 ? _18 : ""]];
                                    // SEKCJA 7 - INFORMACJE O KARCIE PRZEKAZANIA ODPADÓW
                                    // approvedByUser, approvalDate, approvalTime, transportConfirmedByUser, transportConfirmationDate, transportConfirmationTime, receiveConfirmedByUser, receiveConfirmationDate, receiveConfirmationTime,
                                    sheet.getRange("A95").values = [[(_19 = kpoPrintData.approvedByUser) !== null && _19 !== void 0 ? _19 : ""]];
                                    sheet.getRange("C95").values = [[(_20 = kpoPrintData.approvalDate) !== null && _20 !== void 0 ? _20 : ""]];
                                    sheet.getRange("E95").values = [[(_21 = kpoPrintData.approvalTime) !== null && _21 !== void 0 ? _21 : ""]];
                                    sheet.getRange("A103").values = [[(_22 = kpoPrintData.transportConfirmedByUser) !== null && _22 !== void 0 ? _22 : ""]];
                                    sheet.getRange("C103").values = [[(_23 = kpoPrintData.transportConfirmationDate) !== null && _23 !== void 0 ? _23 : ""]];
                                    sheet.getRange("E103").values = [[(_24 = kpoPrintData.transportConfirmationTime) !== null && _24 !== void 0 ? _24 : ""]];
                                    sheet.getRange("A99").values = [[(_25 = kpoPrintData.receiveConfirmedByUser) !== null && _25 !== void 0 ? _25 : ""]];
                                    sheet.getRange("C99").values = [[(_26 = kpoPrintData.receiveConfirmationDate) !== null && _26 !== void 0 ? _26 : ""]];
                                    sheet.getRange("E99").values = [[(_27 = kpoPrintData.receiveConfirmationTime) !== null && _27 !== void 0 ? _27 : ""]];
                                    // SEKCJA 8 - DODATKOWE INFORMACJE
                                    // additionalInfo, 
                                    sheet.getRange("A107").values = [[(_28 = kpoPrintData.additionalInfo) !== null && _28 !== void 0 ? _28 : "brak"]];
                                    return [4 /*yield*/, context.sync()];
                                case 1:
                                    _29.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=kpo_card_print.js.map